import { title } from "process";
import { TopItem } from "../../models/Dashboard";
import "./DashboardStyleSheet.css";

const TopArtworksCard: React.FC<{ pageTitle: string, items: TopItem[], showImage: boolean }> = ({ pageTitle, items, showImage }) => (
    <div className="dashboard-card">
        <div className="dashboard-card-header"><h2>{pageTitle}</h2></div>
        <div className="dashboard-card-body">
            {items.map((item, i) => (
                <div key={item.id} className="top-item">
                    <span className="top-item-rank">{i + 1}</span>
                    {showImage && item.imageUrl && (
                        <img
                            src={item.imageUrl}
                            alt={item.title}
                            className="top-item-thumb"
                        />
                    )}
                    <div className="top-item-meta">
                        <div className="top-item-title">{item.title}</div>
                        {item.subtitle && (
                            <div className="top-item-subtitle">{item.subtitle}</div>
                        )}
                    </div>
                    <div className="top-item-value">{item.valueFormatted}</div>
                </div>
            ))}
        </div>
    </div>
);
export default TopArtworksCard;